import defaultAttributes from '../defaultAttributes';

const Tv = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '2', y: '7', width: '20', height: '15', rx: '2', ry: '2' }],
    ['polyline', { points: '17 2 12 7 7 2' }],
  ],
];

export default Tv;
